/**
 * The stamp on a resolved row, plus the Review button — which every row carries,
 * resolved included. With the whole-row click gone this button is the ONLY way
 * into the detail page, and a resolved item is exactly where Reopen lives, so
 * omitting it here would strand that action behind no affordance at all.
 */
import { Link } from 'react-router-dom';

import { Avatar } from '../../dashboards/primitives';
import { resolvedStamp } from '../reviewQueueModel';
import type { ReviewQueueItem } from '../reviewTypes';

export default function ReviewQueueActionCell({
  item,
  muted,
}: {
  item: ReviewQueueItem;
  muted: boolean;
}) {
  const stamp = muted ? resolvedStamp(item) : null;
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 8 }}>
      {stamp && (
        <>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--nb-muted)' }}>
              {stamp.name}
            </div>
            <div style={{ fontSize: 10.5, color: 'var(--nb-muted)' }}>{stamp.at}</div>
          </div>
          <Avatar name={stamp.name} size={24} />
        </>
      )}
      {/* A LINK styled as a button, not a button calling navigate(): this is
          navigation, and a triage queue is exactly where someone middle-clicks to
          open three items in tabs. A button gave no href, so that was impossible
          and there was nothing to copy.
          "View" on a resolved row, because there is nothing left to review — the
          page it opens offers Reopen, not a resolve. */}
      <Link
        to={`/admin/needs-review/${item.kind}/${item.id}`}
        // Filled green on an OPEN row, plain outline on a resolved one. The
        // resolved row's affordance still has to be readable — it is the only way
        // to reach Reopen — so it recedes by losing the fill, not by being dimmed.
        className={muted ? 'nb-btn' : 'nb-btn nb-btn-primary'}
        style={{ height: 28, fontSize: 12, textDecoration: 'none' }}
        // The row no longer carries a label of its own, and a table of
        // identically-named controls is unusable by voice or screen reader, so
        // the accessible name names the row. It still STARTS with the visible
        // word (WCAG 2.5.3 Label in Name).
        aria-label={`${muted ? 'View' : 'Review'} ${item.kind} ${item.reference}`}
      >
        {muted ? 'View' : 'Review'}
      </Link>
    </div>
  );
}
